export default "__VITE_ASSET__oghm2Rcg__"